import TaskReportParameters from '@/app/activations/models/TaskReportParameters'
import TaskFormResponse from '@/app/activations/models/TaskFormResponse'

/* eslint-disable camelcase */
export default class ActivationTask {
  constructor ({ start_date, end_date, description, report_parameters, id, survey_id, task_form_responses }) {
    this.startDate = start_date
    this.endDate = end_date
    this.description = description
    this.reportParameters = new TaskReportParameters(report_parameters)
    this.id = id
    this.surveyId = survey_id
    this.taskFormResponses = task_form_responses.map(rawTaskFormResponse => new TaskFormResponse(rawTaskFormResponse))
  }

  get badPrices () {
    const activationPrice = this.reportParameters.activationPrice
    return this.taskFormResponses
      .filter(taskFormResponse => Number(taskFormResponse.response.price.value) &&
      Number(taskFormResponse.response.price.value) !== Number(activationPrice)).length
  }
}



// WEBPACK FOOTER //
// ./src/app/activations/models/ActivationTask.js